import {Box, styled, SvgIcon, Tooltip} from "@mui/material"
import {useEffect,} from "react"
import {TabPanel, NavPanel} from "../panels/TabPanel"
import {
	NavigationTabWrapper,
	NavigationTab,
	NavigationTabs,
	NavigationSecondaryFnWrapper,
	NavigationWrapper,
} from "../panels/Navigation"
import {
	Build,
	FileOpen,
	//FindReplace,
	Search,
	Notifications,
	CloudUpload
} from "@mui/icons-material"
import { SearchPanel } from "./SearchPanel/SearchPanel"
import { SearchPanelNav } from "./SearchPanel/SearchPanelNav"
import { NoteArticleListPanelNav } from "./NoteArticleList/NoteArticleListPanelNav"
import { useDispatch, useSelector } from "react-redux"
import { ToolPanel, ToolPanelNav } from "./ToolPanel"
import { AutomatedSearchPanel } from "./auto_search_panel/AutomatedSearchPanel"
import { AutomatedSearchPanelNav } from "./auto_search_panel/AutomatedSearchPanelNav"
import {PubMedIcon} from "../../PubMedIcon"
import { DashboardMenu } from "../DashboardMenu"
import MultiSelect from "./MultiSelect"
import FormattedToolTip from "../../utils/FormattedToolTip"
import NotificationPanel from "./Notifications/NotificationPanel"
import NotificationPanelNav from "./Notifications/NotificationPanelNav"
import {fetchSentNotifications, fetchUserNotifications} from "../../reducers/notificationsSlice"
import { selectUnreadNotifications } from "../../reducers/notificationsSlice"
import {DYNAMIC_PANEL_TAB_INDEX_MAP, selectDynamicView, setDynamicView} from "../../reducers/dynamicViewSlice"
import CitationImportNav from "./CitationImport/CitationImportNav"
import CitationImportPanel from "./CitationImport/CitationImportPanel"
import {useWorkspaceContext} from "../../pages/Dashboard"
import {NoteArticleList} from "./NoteArticleList/NoteArticleList"

const DynamicNavToolTip = styled(Tooltip)({})
DynamicNavToolTip.defaultProps = {
	slotProps: {
		popper: {
			modifiers: [
				{
					name: "offset",
					options: {
						offset: [0, 30],
					},
				},
			],
		},
	},
	disableInteractive: true,
}

function DynamicPanelNav({
	openTab,
	workspace,
}) {
	const notifications = useSelector(selectUnreadNotifications)
	const dispatch = useDispatch()
	const {workspaceId, panelSlot} = useWorkspaceContext()
	const handleChangeTab = (event, newValue) => {
		dispatch(setDynamicView({newValue, workspaceId}))
	}

	return (
		<NavigationWrapper>
			<NavigationTabWrapper>
				<NavigationTabs
					value={openTab}
					onChange={handleChangeTab}
					aria-label="dynamic-tabs"
				>
					<NavigationTab
						value={DYNAMIC_PANEL_TAB_INDEX_MAP.ARTICLE_SEARCH}
						icon={
							<DynamicNavToolTip
								title={
									<FormattedToolTip
										title={"Search Once"}
										description={"For Articles in PubMed or my Workspace."}
									/>
								}
							>
								<Search />
							</DynamicNavToolTip>
						}
						aria-label="article-searching"
					/>
					<NavigationTab
						value={DYNAMIC_PANEL_TAB_INDEX_MAP.NOTE_ARTICLE_LIST}
						icon={
							<DynamicNavToolTip
								title={
									<FormattedToolTip
										title={"Articles"}
										description={"Attached to a note."}
									/>
								}
							>
								<FileOpen />
							</DynamicNavToolTip>
						}
						aria-label="note-articles"
					/>
					<NavigationTab
						value={DYNAMIC_PANEL_TAB_INDEX_MAP.TOOLS}
						icon={
							<DynamicNavToolTip
								title={
									<FormattedToolTip
										title={"Tools"}
										description={"Your recently viewed and excluded articles."}
									/>
								}
							>
								<Build />
							</DynamicNavToolTip>
						}
						aria-label="tools"
					/>
					{ (workspace.permissions.write || workspace.permissions.admin) &&
						<NavigationTab
							value={DYNAMIC_PANEL_TAB_INDEX_MAP.AUTOMATED_SEARCH}
							icon={
								<DynamicNavToolTip
									title={
										<>
											<FormattedToolTip
												title={"Automated Searches to PubMed"}
											/>
										</>
									}
								>
									<SvgIcon>
										<PubMedIcon />
									</SvgIcon>
								</DynamicNavToolTip>
							}
							aria-label="automated-search"
						/>
					}
					<NavigationTab
						value={DYNAMIC_PANEL_TAB_INDEX_MAP.NOTIFICATION}
						icon={
							<DynamicNavToolTip
								title={
									<>
										<FormattedToolTip
											title={"Notifications"}
											description={"View shared articles and other notifications."}
										/>
									</>
								}
							>
								{
									notifications.length > 0 ? (
										<div style={{position: "relative", overflow: "visible"}}>
											<div style={{position: "absolute", bottom: "0px", left: "16px", paddingLeft: "4px", paddingRight: "4px",  paddingTop: "1px", paddingBottom: "1px", backgroundColor: "red", borderRadius: "4px"}}>
												<div style={{fontSize: "0.75rem", color: "white"}}>{notifications.length}</div>
											</div>
											<Notifications />
										</div>
									) : (
										<Notifications />
									)
								}
							</DynamicNavToolTip>
						}
						aria-label="notifications"
					/>
					<NavigationTab
						value={DYNAMIC_PANEL_TAB_INDEX_MAP.NON_PUBMED_IMPORT}
						icon={
							<DynamicNavToolTip
								title={
									<>
										<FormattedToolTip
											title={"Import Citations"}
											description={"Import specific citations by ID."}
										/>
									</>
								}
							>
								<CloudUpload />
							</DynamicNavToolTip>
						}
						aria-label="citation-import"
					/>

				</NavigationTabs>
				<span style={{ flexGrow: 1 }} />
				{
					panelSlot === "primary" && (<DashboardMenu onDashboard={true} />)
				}
			</NavigationTabWrapper>
			<Box sx={{ background: "white" }}>
				<NavigationSecondaryFnWrapper>
					<NavPanel
						value={openTab}
						index={DYNAMIC_PANEL_TAB_INDEX_MAP.ARTICLE_SEARCH}
					>
						<SearchPanelNav />
					</NavPanel>
					<NavPanel
						value={openTab}
						index={DYNAMIC_PANEL_TAB_INDEX_MAP.NOTE_ARTICLE_LIST}
					>
						<NoteArticleListPanelNav />
					</NavPanel>
					<NavPanel value={openTab} index={DYNAMIC_PANEL_TAB_INDEX_MAP.TOOLS}>
						<ToolPanelNav />
					</NavPanel>
					<NavPanel
						value={openTab}
						index={DYNAMIC_PANEL_TAB_INDEX_MAP.AUTOMATED_SEARCH}
					>
						<AutomatedSearchPanelNav />
					</NavPanel>
					<NavPanel value={openTab} index={DYNAMIC_PANEL_TAB_INDEX_MAP.NOTIFICATION}>
						<NotificationPanelNav />
					</NavPanel>
					<NavPanel value={openTab} index={DYNAMIC_PANEL_TAB_INDEX_MAP.NON_PUBMED_IMPORT}>
						<CitationImportNav />
					</NavPanel>

				</NavigationSecondaryFnWrapper>
			</Box>
		</NavigationWrapper>
	)
}

export default function DynamicPanel({
	workspace,
	setOpenWorkspaceManager,
	setOpenSupportModal,
	setOpenWorkspacePermissions
}) {
	const dispatch = useDispatch()
	const {workspaceId} = useWorkspaceContext()
	const openTab = useSelector((state) => selectDynamicView(state, workspaceId))

	useEffect(() => {
		dispatch(fetchUserNotifications())
		dispatch(fetchSentNotifications())
	}, [dispatch])

	return (
		<Box
			//id="panel-container"
			id={"dynamic-panel-content-wrapper"}
			sx={{backgroundColor: "primary.rOneBG", display: "flex", flexDirection: "column", position: "relative"}}
		>
			<DynamicPanelNav
				openTab={openTab}
				workspace={workspace}
				setOpenWorkspaceManager={setOpenWorkspaceManager}
				setOpenSupportModal={setOpenSupportModal}
				setOpenWorkspacePermissions={setOpenWorkspacePermissions}
			/>
			<TabPanel
				value={openTab}
				index={DYNAMIC_PANEL_TAB_INDEX_MAP.ARTICLE_SEARCH}
			>
				<SearchPanel />
			</TabPanel>
			<TabPanel
				value={openTab}
				index={DYNAMIC_PANEL_TAB_INDEX_MAP.NOTE_ARTICLE_LIST}
			>
				<NoteArticleList />
			</TabPanel>
			<TabPanel value={openTab} index={DYNAMIC_PANEL_TAB_INDEX_MAP.TOOLS}>
				<ToolPanel />
			</TabPanel>
			<TabPanel
				value={openTab}
				index={DYNAMIC_PANEL_TAB_INDEX_MAP.AUTOMATED_SEARCH}
			>
				<AutomatedSearchPanel />
			</TabPanel>
			<TabPanel value={openTab} index={DYNAMIC_PANEL_TAB_INDEX_MAP.NOTIFICATION}>
				<NotificationPanel/>
			</TabPanel>
			<TabPanel value={openTab} index={DYNAMIC_PANEL_TAB_INDEX_MAP.NON_PUBMED_IMPORT}>
				<CitationImportPanel />
			</TabPanel>
			<MultiSelect/>
		</Box>
	)
}
